import type { Moment } from '../../types/stage';

const focusLine = 'Focus · ik meld alleen wat dringend is';

export const moments: Moment[] = [
  { id: 'rust', time: '08:14', title: 'Rust', mode: 'Vrij', daypart: 'ochtend', base: 'rust', view: 'stage' },
  {
    id: 'ochtend',
    time: '08:15',
    title: 'Goedemorgen',
    mode: 'Vrij',
    daypart: 'ochtend',
    base: 'rust',
    view: 'stage',
    speech: 'Goedemorgen. Je eerste afspraak is om 10:00. Ik heb vannacht de build van project X gerepareerd.',
    cards: [
      { kind: 'vandaag', side: 'links', atWord: 2 },
      { kind: 'vannacht', side: 'rechts', atWord: 9 },
      { kind: 'koffie', side: 'links', atWord: 15 },
    ],
  },
  {
    id: 'focus',
    time: '10:52',
    title: 'Focusblok',
    mode: 'Focus',
    daypart: 'focus',
    base: 'nietStoren',
    view: 'stage',
    quietLine: focusLine,
  },
  {
    id: 'deur',
    time: '11:20',
    title: 'Iemand aan de deur',
    mode: 'Focus',
    daypart: 'focus',
    base: 'nietStoren',
    view: 'stage',
    pulse: true,
    quietLine: focusLine,
    cards: [{ kind: 'deur', side: 'rechts' }],
  },
  {
    id: 'lisa',
    time: '12:30',
    title: 'Meeting met Lisa',
    mode: 'Vrij',
    daypart: 'middag',
    base: 'rust',
    view: 'stage',
    chime: true,
    speech: 'Je meeting met Lisa begint om 14:00. Het gaat regenen – neem een paraplu, kleed je zakelijk, en vertrek om 13:30.',
    cards: [
      { kind: 'lisa', side: 'links', atWord: 3 },
      { kind: 'weer', side: 'rechts', atWord: 9 },
      { kind: 'route', side: 'rechts', atWord: 18 },
    ],
  },
  {
    id: 'verwarming',
    time: '12:31',
    title: 'Niveau 2',
    mode: 'Vrij',
    daypart: 'middag',
    base: 'rust',
    view: 'stage',
    keepCards: true,
    speech: 'Ik zet de verwarming in de werkkamer lager terwijl je weg bent, tenzij je stopt.',
    cards: [{ kind: 'verwarming', side: 'links', atWord: 3 }],
  },
  {
    id: 'goedkeuren',
    time: '12:35',
    title: 'Wacht op jou',
    mode: 'Vrij',
    daypart: 'middag',
    base: 'rust',
    view: 'approvals',
    speech: 'Drie dingen wachten op je ok.',
  },
  { id: 'slapen', time: '22:40', title: 'Slapen', mode: 'Slapen', daypart: 'nacht', base: 'slaapt', view: 'sleep' },
  {
    id: 'waterlek',
    time: '03:12',
    title: 'Veiligheidsalarm',
    mode: 'Slapen',
    daypart: 'alarm',
    base: 'bezorgd',
    view: 'alarm',
    speech: 'De sensor bij de vaatwasser meldt water in de keuken.',
  },
];
